import React, { useRef } from 'react';

import { useEditor } from '../../hooks/useEditor';
import { DocumentNodeCache, renderNode } from '../../utils/renderNode';
import * as S from './Canvas.style';
import { PreviewModeContainer } from './PreviewModeContainer';

export interface CanvasProps {
  id?: string;
  className?: string;
  width: number;
}

export function Canvas({
  width,
  id,
  className,
}: CanvasProps): React.ReactElement {
  const {
    state: { document, displayMode },
    components,
  } = useEditor();

  const cacheRef = useRef<DocumentNodeCache>({});

  const Container = displayMode === 'edit' ? S.Container : PreviewModeContainer;

  return (
    <Container id={id} className={className}>
      <S.Scroller id="canvas-scroller">
        <S.Viewport id="canvas-viewport" width={width}>
          <S.Content id="canvas-content" shadow={displayMode === 'edit'}>
            { renderNode(document, components, [], cacheRef.current) }
          </S.Content>
        </S.Viewport>
      </S.Scroller>
      <div id="highlighter-root" style={{ position: 'relative' }} />
    </Container>
  );
}
